import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const NotebookIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 1 33 33"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.03 6.48c1.314 0 2.395 1.044 2.395 2.35v18.427a1.631 1.631 0 0 1 1.263 1.593c0 .903-.726 1.633-1.622 1.633H1.786c-.895 0-1.62-.73-1.62-1.633 0-.777.539-1.428 1.26-1.593V8.83c0-1.306 1.081-2.35 2.395-2.35h27.21ZM20.64 28.025h-6.517a.729.729 0 0 0-.725.731c0 .404.324.732.725.732h6.518a.73.73 0 0 0 .725-.732.73.73 0 0 0-.725-.731ZM3.822 8.64h27.21l.076.01c.096.028.158.103.158.18l-.002 18.386H3.585L3.587 8.83c0-.096.097-.19.234-.19Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default NotebookIcon;
